import api from '../api/api'
import { state } from '@/store/project'

export default class {
  constructor(baseUrl) {
    this.state = {
      baseUrl: baseUrl,
      dialog: false,
      loading: false,
      selectedRevision: null,
      baseRevision: {
        name: '',
        selected_revision: null
      }
    }
    this.mutations = {
      TOGGLE_REVISION_DIALOG(state) {
        state.dialog = !state.dialog
      },
      TOGGLE_LOADING(state) {
        state.loading = !state.loading
      },
      SET_SELETECTED_REVISION(state, item) {
        state.selectedRevision = item
      }
    }
    this.actions = {
      async fetchRevision({ state, commit }, id) {
        let url = state.baseUrl + `${id}/`
        let response = await api.get(url)
        commit('SET_SELETECTED_REVISION', response['data'])
      },
      async createRevision(context, { parameter, payload }) {
        context.commit('TOGGLE_LOADING')
        let response = await api.post(context.state.baseUrl, payload)
        await context.dispatch(
          'project/addRevision',
          {
            parameter,
            revision: response.data
          },
          { root: true }
        )
        context.commit('TOGGLE_LOADING')
      },
      async updateSelectedRevision(context, { id, parameter, selectedRevision }) {
        const url = `/project_user/${id}/`
        const data = {}
        data[parameter] = selectedRevision.id
        await api.patch(url, data)
        context.commit('SET_SELETECTED_REVISION', selectedRevision)
        await context.dispatch(
          'project/updateRevision',
          { parameter, selectedRevision: selectedRevision.id },
          { root: true }
        )
      },
      setSelectedRevision(context, revision) {
        context.commit('SET_SELETECTED_REVISION', revision)
      },
      setSelectedRevisionById(context, { revisionSet, id }) {
        let selectedRevision = revisionSet.find((revision) => revision.id === id)
        context.commit('SET_SELETECTED_REVISION', selectedRevision)
      },
      toggleRevisionDialog(context) {
        context.commit('TOGGLE_REVISION_DIALOG')
      }
    }
    this.getters = {}
  }
}
